
export const slbCart = {
    cart: {
        title: "My Cart",
        back: "All offerings",
        continue: "Continue",
        clear: "Clear Cart",
        close: "Close",
        cancel: "Cancel",
        checkout: "Checkout",
        alert: {
            notFullyOnboarded: "Your email address suggests that you are currently affiliated with one of our services.<br>A SLB representative will be reaching out to you soon",
            notSupportCountryNextCart: "You are welcome to browse our offerings, but the ability to complete a purchase online for this offering is not yet available. If you wish to speak to a Sales Representative, you can <span id='contactUs'>Contact Us</span>, otherwise you can continue browsing.",
            notSupportCountryCart: "You are welcome to browse our offerings, but the ability to complete a purchase online for this offering is not yet available. If you wish to speak to a Sales Representative, you can <span id='contactUs'>Contact Us</span>, otherwise you can continue browsing.",
            dowJonesFlagged: "Your commerce registration has not been completed, to verify this please click here <span id='contactUs'>Contact Us</span>",
            notBuyOption: "You are welcome to browse our offerings, but the ability to complete a purchase online for this offering is not yet available. If you wish to speak to a Sales Representative, you can <span id='contactUs'>Contact Us</span>, otherwise you can continue browsing.",
            nextClassExpired: "The registration time for this class has expired. Go back to next and select a new class",
            hasNotListedProducts: "The cart contains an item that is not allowed to be purchased: {{productName}}. Please remove it to proceed with checkout or contact support for further assistance."
        }
    },
    delfi: {
        title: "Selected Cloud Solutions",
        selectedProfile: "Selected profile",
        quantity: "Quantity",
        duration: "Duration",
        cost: "Monthly cost",
        solution: {
            PTS: 'Delfi Domain Profiles',
            ODRS: 'On Demand Reservoir Simulation',
            PTS_OPTION: 'Delfi Domain Profiles Options',
            DRILLPLAN: 'Delfi Applications'
        },
        alert: {
            PTS_OPTION: "OFM Base is an add-on which needs to be ordered with a Delfi Domain profile. Please select in order to continue."
        }
    },
    mixed: {
        title: "Mixed order",
        description: "You are unable to submit an order that contains products from 2 different solutions<br/><br/>You already have products in your cart for a different solution ({{solution}})<br/><br/>However, you can purchase them individually",
        replace: "Replace Existing Cart",
        notAdd: "Do Not Add The Product",
        license: {
            description: "You are unable to submit an order that contains products from 2 different license types<br/><br/><ul style='margin-left:20px'><li>{{currentLicense}}</li><li>{{newLicense}}</li></ul>However, you can purchase them individually"
        }
    },
    agora: {
        product: "Product",
        quantity: "Quantity",
        price: "Price,",
        subTotal: "Sub-total",
        included: "Included in subscription",
        estimated: "Estimated total payment today",
        estimatedYear: "Estimated amount due each year after",
        estimatedMonth: "Estimated amount due each month after",
        year: '/ year',
        month: '/ month',
        firstYear: '/ first year',
        discountApplications: "Annual discount applied for applications",
        discountExplorer: "Data Explorer first year discount applied",
        addDataExplorer: "Add Data Explorer",
        addGatewayService: "Add installation services",
        subscription: "Edge Applications subscription",
        devices: "Agora Gateway devices",
        terms: "I already own required v.402/403 Gateways device(s). I am aware that 1 Gateway device supports up to 15 instances of each application",
        required: "Selected Edge Applications require Agora Gateway devices to run",
        notEnough: "More gateways required to support all selected application",
        addGateways: "Add Gateways",
        yearly: "<strong>Yearly</strong> (10% Discount For Edge Apps)",
        monthly: "<strong>Monthly</strong>",
        minimum: "min 3 month commitment",
        notSupported: "not supported by Data Explorer",
        selectPeriod: "Select period"
    },
    service: {
        product: "Service",
        quantity: "Quantity",
        total: "Total",
    },
    ocean: {
        license: "License",
        unitPrice: "Unit price",
        quantity: "Quantity",
        maintenance: "Maintenance",
        total: "Total price",
        product: "Product name",
        tillDate: "Till {{date}} Dec 31",
        tax: "* The tax would be reflected on your final quote",
        duration: "Duration",
        durationValue: "2 Weeks",
        included: "Included",
        title: "My cart: Ocean (Rent & Buy)", 
        titleFree: "My cart: Ocean (Evaluation)", 
        newProducts: "New Cart With All My Products",
        new: "New Cart",
        description: "All your products will be added with the following license type:",
        create: "Create new cart",
        cartLost: "Current cart will be lost.",
        advise: "* Please note that entire order will be licensed to a single server/server triad",
        sales: "Sale & Rental",
        evaluation: "Ocean (Evaluation)",
        university: "Ocean (University)",
        development: "Ocean (Development)"
    },
    next: {
        startDate: "Start date",
        endDate: "End date",
        country: "Class country",
        location: "Location",
        total: "Total",
        notApply: "N/A",
        product: "Title",
        elearning: "e-learning"
    },
    subscription: {
        category: {
            "delfi-domain-profiles": "Delfi Domain Profiles",
            "on-demand-reservoir-simulation": "On-Demand Reservoir Simulation",
            "petrotechnical-suite-options": "Petrotechnical Suite Options",
            "delfi-applications" : "Delfi Applications"
        },
        title: 'Selected Subscriptions'
    },
    notListed: {
        title: "Product Not Listed",
        notAdd: "OK, I got it"
    }
};